import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
// import 'react-h5-audio-player/lib/styles.css';
import { Button, Tooltip } from 'antd';


const getStyle = (styles, maxWidth='650px', playerMarginLeft='0px', playerMarginRight='0px', playerPadding='10px 15px') => {
  const playerBGColor = styles.player_bg || '#fff';
  const textColor = styles.color || '#4A90E2';
  const primaryColor = styles.primary_color || '#4A90E2';
  const secondaryColor = styles.secondary_color || '#f9afaf';

    let style = `.rhap_container {
      max-width: ${maxWidth};
      background: ${playerBGColor} !important;,
      margin-left: ${playerMarginLeft},
      margin-right: ${playerMarginRight},
      padding: ${playerPadding}
  }
  
  .rhap_container * {
      line-height: 0.5 !important;
  }
  
  .rhap_container .rhap_progress-section {
      padding: 10px!important;
  }
  
  .rhap_container .rhap_main-controls * {
      font-size: 60px !important;
      width: 60px !important;
      height: 60px !important;
  }
  
  .rhap_container .rhap_controls-section div {
      color: ${textColor} !important;
      word-wrap: anywhere;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      line-height: 1 !important;
  }
  
  .rhap_container .rhap_controls-section div.title {
      max-width: 40%!important;
      min-width: 200px;
  }
  
  .rhap_container .rhap_time {
      color: ${primaryColor}!important;
  }
  
  .rhap_container .rhap_progress-indicator {
      background: ${primaryColor}!important;
  }
  
  .rhap_container .rhap_progress-filled {
      background: ${primaryColor}!important;
  }
  
  .rhap_container .rhap_download-progress{
      background: ${secondaryColor} !important;
  }

  .rhap_container .rhap_progress-bar-show-download{
      background: ${secondaryColor} !important;
  }
  
  .rhap_container .rhap_main-controls .rhap_main-controls-button svg {
      color: ${primaryColor}!important;
  }
  
  .rhap_container .rhap_volume-controls svg {
      color: ${primaryColor}!important;
  }
  
  .rhap_container .rhap_volume-controls .rhap_volume-bar {
      background: ${secondaryColor} !important;
  }
  
  .rhap_container .rhap_volume-controls .rhap_volume-bar .rhap_volume-indicator {
      background: ${primaryColor}!important;
  }
  
  .rhap_footer {
      display: flex;
      padding: 10px 0px 13px 0px;
      justify-content: flex-end;
  }
  
  .rhap_footer div.branding {
      opacity: 0.5;
      user-select: none;
  }
  
  media only screen and (max-width: 768px) {
    .rhap_container .rhap_controls-section {
        display: none!important;
    }
  }`
  return style;
}


const AudioPlayerH5 = forwardRef(({ url, audioTitle, playerCSS, showFooter=true, autoPlay=true, layout='stacked', 
    maxWidth='650px', playerMarginLeft='0px', playerMarginRight='0px', showVolume = true, handleAudioListen = null, 
    preload='auto', boxShadow=true, playerPadding='10px 15px' }, ref) => {
  const[audioURL, setAudioURL] = useState(null);
  const [title, setTitle] = useState(null);
  const [brandCSS, setBrandCSS] = useState(null);

  const playerRef = useRef(null);

  useImperativeHandle(ref, () => ({
    updateVolume(vol) {
        if(playerRef && playerRef.current) {
            playerRef.current.audio.current.volume = vol / 100;
        }        
    }
  })); 

  useEffect(() => {
        if(url) {
            setAudioURL(url);
        }
        if(audioTitle) {
            setTitle(audioTitle);
        }
        if(playerCSS) {
            setBrandCSS(playerCSS);
        }
    return () => {};
  }, [url, audioTitle, playerCSS]);
  
  useEffect(() => {
    let styleTag = null;

    if(brandCSS) {
      //styleTag = document.createElement('style');
      styleTag = document.getElementById("idAudioPlayerStyles")
      let playerStyles = getStyle(brandCSS, maxWidth=maxWidth, playerMarginLeft=playerMarginLeft, playerMarginRight=playerMarginRight, playerPadding=playerPadding);
      //console.log(playerStyles);
      styleTag.appendChild(document.createTextNode(playerStyles));
      document.head.appendChild(styleTag);
    }

    return () => {
      if(styleTag) {
        //document.head.removeChild(styleTag);
        styleTag.innerHTML = "";
      }      
    };
  }, [title, brandCSS]);

  useImperativeHandle(ref, () => ({
    seekTo: (time) => {
      if (playerRef.current && playerRef.current.audio.current) {
        playerRef.current.audio.current.currentTime = time;
      }
    }
  }));

  return (
    <>
      {
        audioURL && 
        <AudioPlayer
            autoPlay={autoPlay}
            src={audioURL}
            ref={playerRef}
            onPlay={e => console.log("onPlay")}
            footer={showFooter?<div className='branding'>Powred by <a href='https://unmixr.com'>Unmixr</a></div>:null}
            showSkipControls={false}
            showJumpControls={false}
            preload={preload}
            onListen={(e) => {
                const currentTime = e.target.currentTime;
                if (handleAudioListen) {
                  handleAudioListen(currentTime);
                }
              }}
            loop={false}
            customAdditionalControls={[]}
            customControlsSection={
            [
                // <div className='title'><Tooltip title={title}>Title: {title}</Tooltip></div>,
                // RHAP_UI.ADDITIONAL_CONTROLS,
                RHAP_UI.MAIN_CONTROLS,
                ...(showVolume ? [RHAP_UI.VOLUME_CONTROLS] : []),
            ]}
            // customVolumeControls={[]}
            layout={layout}
            style={{boxShadow: boxShadow?'':'none'}}
        />
        }
    </>
  );
});

export default AudioPlayerH5;
